// extracted by mini-css-extract-plugin
module.exports = {"main":"WishList_main__2Whsn","topBar":"WishList_topBar__1ivRD","header":"WishList_header__14Vcv","cards":"WishList_cards__2uivt"};